import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { angelopolisApi } from "../../api/angelopolisAPi";
import model from "../../assets/models/Numeracion_9.glb";

export class GlbNumeracion extends Mesh {
  constructor(loadingManager) {
    super();
    let loader = new GLTFLoader(loadingManager);
    let dracoloader = new DRACOLoader();
    this.angelApi = new angelopolisApi();

    dracoloader.setDecoderPath(
      "https://www.gstatic.com/draco/versioned/decoders/1.5.5/"
    );
    this.loading = loader;
    loader.setDRACOLoader(dracoloader);
    this.onLoadModel(loader);
    this.scale.set(1, 1, 1);
    this.position.set(120, -7.95, -290);
    // this.rotation.y += 0.03;
  }

  // "Z_nuevaZona1""Priv_santa_monica4"
  onLoadModel(loader) {
    loader.load(model, (gltf) => {
      this.add(gltf.scene);

      this.Arcadia = gltf.scene.getObjectByName("Arcadia001");
      this.Bali = gltf.scene.getObjectByName("Bali001");
      this.Capri = gltf.scene.getObjectByName("Capri001");
      this.Creta = gltf.scene.getObjectByName("Creta001");
      this.Fontana = gltf.scene.getObjectByName("Fontana001");
      this.Galena = gltf.scene.getObjectByName("Galena001");
      this.LaCantera = gltf.scene.getObjectByName("LaCantera001");
      this.Lucerna = gltf.scene.getObjectByName("Lucerna001");
      this.Rinconada = gltf.scene.getObjectByName("Rinconada001");
      this.Rodas = gltf.scene.getObjectByName("Rodas001");
      this.Sacramento = gltf.scene.getObjectByName("Sacramento001");
      this.Vilansa = gltf.scene.getObjectByName("Vilansa001");
      this.Balcanes = gltf.scene.getObjectByName("Balcanes");
      this.Antalya = gltf.scene.getObjectByName("Antalya");
      this.Niza = gltf.scene.getObjectByName("Niza001");
      this.Sorrento = gltf.scene.getObjectByName("Sorrento");
      this.Trento = gltf.scene.getObjectByName("Trento");
      this.Verona = gltf.scene.getObjectByName("Verona");
      this.Zante001 = gltf.scene.getObjectByName("Zante001");
      this.Ferrara001 = gltf.scene.getObjectByName("Ferrara001");
      this.Siena_Num = gltf.scene.getObjectByName("Siena_Num");
      this.Montenegro_num = gltf.scene.getObjectByName("Montenegro_num");
      this.TerraVerde_num = gltf.scene.getObjectByName("TerraVerde");
      this.Milos_num = gltf.scene.getObjectByName("Milos");

      this.Balcanes.position.y += 0.15;
      // this.Palermo = gltf.scene.getObjectByName("Palermo");
      // this.Parque_berna = gltf.scene.getObjectByName("Parque_berna");
      // this.ParqueViena = gltf.scene.getObjectByName("ParqueViena");
      // this.Sofia = gltf.scene.getObjectByName("Sofia");
      // this.Anturio = gltf.scene.getObjectByName("Anturio");

      this.validateandModificateClusters();
    });
  }
  validateandModificateClusters() {
    const uiElements = [
      {
        father: this.menuZoneOne,
        childrens: [
          {
            //fontana
            meshElement: this.Fontana,
            slug: "A-110 B",
          },
          {
            //sacramento
            meshElement: this.Sacramento,
            slug: "A-110A",
          },
          {
            //arcadia
            meshElement: this.Arcadia,
            slug: "A-108 B",
          },
          {
            //rinconada
            meshElement: this.Rinconada,
            slug: "A-106",
          },
          {
            //galena
            meshElement: this.Galena,
            slug: "A108A/A109",
          },
          {
            //Milos
            meshElement: this.Milos_num,
            slug: "A-101D",
          },
        ],
      },
      {
        father: this.menuZoneTwo,
        childrens: [
          {
            //capri
            meshElement: this.Capri,
            slug: "*************",
          },
          {
            //creta
            meshElement: this.Creta,
            slug: "A-91",
          },
          {
            //rodas
            meshElement: this.Rodas,
            slug: "*************",
          },
          {
            //bali
            meshElement: this.Bali,
            slug: "D-67AB/D70",
          },
          {
            //antaya
            meshElement: this.Antalya,
            slug: "A-74BC",
          },
          {
            //niza
            meshElement: this.Niza,
            slug: "D62",
          },
        ],
      },

      {
        father: this.menuZoneSeven,
        childrens: [
          {
            //lucerna
            meshElement: this.Lucerna,
            slug: "C-30",
          },
          {
            //cantera
            meshElement: this.LaCantera,
            slug: "D-28",
          },
        ],
      },

      {
        father: this.menuZoneThree,
        childrens: [
          {
            //vilansa
            meshElement: this.Vilansa,
            slug: "A-176",
          },
          {
            //balcanes
            meshElement: this.Balcanes,
            slug: "C3",
          },
          {
            //montenegro
            meshElement: this.Montenegro_num,
            slug: "C4",
          },
          {
            //TerraVerde
            meshElement: this.TerraVerde_num,
            slug: "A-35",
          },
          {
            //Zante
            meshElement: this.Zante001,
            slug: "A-177 B",
          },
        ],
      },
      {
        father: this.menuZoneThree,
        childrens: [
          {
            //Sorrento
            meshElement: this.Sorrento,
            slug: "A-118",
          },
          {
            //Trento
            meshElement: this.Trento,
            slug: "A-119A",
          },
          {
            //Verona
            meshElement: this.Verona,
            slug: "A-114D",
          },
          {
            //this.Ferrara001
            meshElement: this.Ferrara001,
            slug: "A-119B",
          },
          {
            //this.Ferrara001
            meshElement: this.Siena_Num,
            slug: "A-115AB",
          },
        ],
      },
      // {
      //   father: this.menuZoneFive,
      //   childrens: [
      //     // {
      //     //   //parque viena
      //     //   meshElement: this.ParqueViena,
      //     //   slug: "*************",
      //     // },
      //     // {
      //     //   //parque berna
      //     //   meshElement: this.Parque_berna,
      //     //   slug: "*************",
      //     // },
      //     // {
      //     //   //palermo
      //     //   meshElement: this.Palermo,
      //     //   slug: "A-9F1",
      //     // },
      //     // {
      //     //   //sofia
      //     //   meshElement: this.Sofia,
      //     //   slug: "A-9D",
      //     // },
      //   ],
      // },

      // {
      //   father: this.meshElement,
      //   childrens: [
      //     {
      //       //anturio
      //       meshElement: this.Anturio,
      //       slug: "ANTURIO",
      //     },
      //   ],
      // },
    ];
    uiElements.forEach((element) => {
      const hiddenChildren = element.childrens.filter(
        (children) =>
          children.slug === "*************" ||
          this.angelApi.clusters.some(
            (clus) => clus.slug === children.slug && !clus.isOpend
          )
      );
      if (hiddenChildren.length === 0) return;
      hiddenChildren.forEach((children) => {
        children.meshElement.visible = false;
      });
    });
  }

  renderAnimations() {}
}
